// extracted by mini-css-extract-plugin
export var buttonContainer = "tile-carousel-container-module--buttonContainer--c205c";
export var carousel = "tile-carousel-container-module--carousel--38879";
export var container = "tile-carousel-container-module--container--3e00a";
export var controls = "tile-carousel-container-module--controls--c03c0";
export var hideDescriptionMobile = "tile-carousel-container-module--hideDescriptionMobile--34f58";
export var iconTile = "tile-carousel-container-module--iconTile--28f3c";
export var next = "tile-carousel-container-module--next--f5ded";
export var prev = "tile-carousel-container-module--prev--8751f";
export var section = "tile-carousel-container-module--section--79135";
export var smallTile = "tile-carousel-container-module--smallTile--1be31";
export var smallTiles = "tile-carousel-container-module--smallTiles--ee9f1";
export var tile = "tile-carousel-container-module--tile--86b87";
export var tileContent = "tile-carousel-container-module--tileContent--f9838";
export var tileIcon = "tile-carousel-container-module--tileIcon--d2ebf";
export var tileImage = "tile-carousel-container-module--tileImage--34c3d";
export var tileWrapNoDescription = "tile-carousel-container-module--tileWrapNoDescription--188e3";
export var tileWrapper = "tile-carousel-container-module--tileWrapper--0afd0";
export var tiles = "tile-carousel-container-module--tiles--5beed";